// extracted by mini-css-extract-plugin
module.exports = {"axis":"Axis_axis__28t6d","y":"Axis_y__2G02V","horizontal":"Axis_horizontal__3wmo7","x":"Axis_x__3u_Ni"};